import { i18n } from '@/plugins/i18n'

export const settlementStatus = {
    PENDING: 'PENDING', // CREATED or SENT_TO_SHAPARAK, used for user settlement filter
    CREATED:0,
    SENT_TO_SHAPARAK:1,
    ACCEPTED:2,
    REJECTED:3,
    FINAL_PAYED:4,
    PARTIALLY_PAID:5,
    HOLIDAY_REJECTED:6,
}

export const statusStr = {
    CREATED: i18n.t('settlement.status.created'),
    SENT_TO_SHAPARAK: i18n.t('settlement.status.sent_to_shaparak'),
    ACCEPTED: i18n.t('settlement.status.accepted'),
    REJECTED: i18n.t('settlement.status.rejected'),
    FINAL_PAYED: i18n.t('settlement.status.final_payed'),
    PARTIALLY_PAID: i18n.t('settlement.status.partially_payed'),
    HOLIDAY_REJECTED: i18n.t('settlement.status.holiday_rejected'),
    get(status) {
        let status_str = null;
        Object.keys(settlementStatus).forEach(function (item, index) {
            if(settlementStatus[item] === status) {
                status_str = statusStr[item];
            }
        })

        return status_str;
    }
}

export const statusVariant = (status) => {
    if(status === settlementStatus.ACCEPTED || status === settlementStatus.FINAL_PAYED || status === settlementStatus.PARTIALLY_PAID) {
        return 'success';
    }

    if(status === settlementStatus.CREATED) {
        return 'info';
    }

    if(status === settlementStatus.SENT_TO_SHAPARAK) {
        return 'warning';
    }

    if(status === settlementStatus.REJECTED) {
        return 'danger';
    }

    if(status === settlementStatus.HOLIDAY_REJECTED) {
        return 'warning';
    }

    return 'dark';
}

export const statusStrForCommonAccess = {
    PENDING: i18n.t('settlement.status.pending'),
    ACCEPTED: i18n.t('settlement.status.accepted'),
    REJECTED: i18n.t('settlement.status.rejected'),
    FINAL_PAYED: i18n.t('settlement.status.final_payed'),
    HOLIDAY_REJECTED: i18n.t('settlement.status.holiday_rejected'),

    get(status) {
        let status_str = null;

        if (status === 0 || status === 1) status_str = statusStrForCommonAccess['PENDING'];
        else if (status === 2) status_str = statusStrForCommonAccess['ACCEPTED'];
        else if (status === 3) status_str = statusStrForCommonAccess['REJECTED'];
        else if (status === 4) status_str = statusStrForCommonAccess['FINAL_PAYED'];
        else if (status === 6) status_str = statusStrForCommonAccess['HOLIDAY_REJECTED'];

        return status_str;
    }
}

export const statusVariantForCommonAccess = (status) => {
    if (status === settlementStatus.ACCEPTED) {
        return 'success';
    }

    if (status === settlementStatus.FINAL_PAYED) {
        return 'success';
    }

    if (status === settlementStatus.CREATED) {
        return 'warning';
    }

    if (status === settlementStatus.SENT_TO_SHAPARAK) {
        return 'warning';
    }

    if (status === settlementStatus.HOLIDAY_REJECTED) {
        return 'warning';
    }

    if (status === settlementStatus.REJECTED) {
        return 'danger';
    }

    return 'dark';
}
